/**
 * @description: Transform comma separated string to array of strings
 */

export function commaToArrayParser(str: string | null): string[] | undefined {
  if (!str) return undefined;

  return str.split(',');
}
